import React, { FC } from 'react';
import styled from 'styled-components';
import { Maybe } from 'types/schema';

interface IQuantity {
  deliveryQuantity: Maybe<string> | undefined;
  orderedQuantity: number;
}

interface IItemQuantity extends IQuantity {
  uom: string;
}

const ColorQuantity = styled.span<IQuantity>`
  color: ${(prop: IQuantity) =>
    Number(prop.deliveryQuantity) >= prop.orderedQuantity ? 'rgba(0,0,0,0.87)' : '#FF4852'};
`;

export const ItemQuantity: FC<IItemQuantity> = (props) => {
  const { deliveryQuantity, orderedQuantity, uom } = props;

  if (Number(deliveryQuantity) === -1) {
    return (
      <span>
        {orderedQuantity} {uom}
      </span>
    );
  }
  return (
    <ColorQuantity deliveryQuantity={Number(deliveryQuantity)} orderedQuantity={orderedQuantity}>
      {`${deliveryQuantity != null ? `${Number(deliveryQuantity)}/` : ''}${orderedQuantity}`} {uom}
    </ColorQuantity>
  );
};

export default ItemQuantity;
